<div class="container">
  <div class="overlay {{ status }}"></div>
  <div class="content">
    <div class="icon"></div>
    <div class="text text--{{ status }}">{{ statusText }}</div>
  </div>
</div>
